import { createWebflowBundle } from "../../shared/create-bundle";
import { CreditCalculator } from "./credit-calculator";

createWebflowBundle("credit-calculator", CreditCalculator, "CreditCalculator");
